import { Link } from 'react-router-dom';
import { Button } from '@/shared/components/ui/button';
import { Card } from '@/shared/components/ui/card';

type AdvisorProfileErrorStateProps = {
  isNotFound?: boolean;
  onRetry?: () => void;
  fullPage?: boolean;
};

export const AdvisorProfileErrorState = ({
  isNotFound = false,
  onRetry,
  fullPage = false,
}: AdvisorProfileErrorStateProps) => {
  if (isNotFound) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <h1 className="text-6xl font-bold text-foreground">404</h1>
          <p className="text-xl text-muted-foreground">Page not found</p>
          <Link
            to="/dashboard"
            className="inline-block mt-4 px-6 py-3 bg-primary text-primary-foreground rounded-md hover:opacity-90 transition-opacity"
          >
            Go back home
          </Link>
        </div>
      </div>
    );
  }

  const content = (
    <Card className="max-w-lg p-8 text-center">
      <h1 className="text-2xl font-bold text-gray-900 mb-3">
        Unable to load advisor profile
      </h1>
      <p className="text-gray-600 mb-6">
        We encountered an error while loading this advisor profile.
      </p>
      <Button onClick={onRetry} className="bg-[#026857] hover:bg-[#025247]">
        Retry
      </Button>
    </Card>
  );

  if (!fullPage) {
    return <div className="flex justify-center px-4 py-8">{content}</div>;
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      {content}
    </div>
  );
};
